var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgHaidiMonthlyOverviewIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 12,
  height: 12,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#haidiMonthlyOverviewIcon_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M10.5 2.25h-.75V.75a.75.75 0 0 0-1.5 0v1.5h-4.5V.75a.75.75 0 0 0-1.5 0v1.5H1.5A1.5 1.5 0 0 0 0 3.75v6.75A1.5 1.5 0 0 0 1.5 12h1.849l-.925-.924a1.876 1.876 0 0 1-.39-.576H1.5V5.25h9v5.25H8.651l-1.5 1.5H10.5a1.5 1.5 0 0 0 1.5-1.5V3.75a1.5 1.5 0 0 0-1.5-1.5Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.78 7.72a.75.75 0 0 0-1.06 0l-2.47 2.47-.97-.97a.75.75 0 0 0-1.06 1.06l1.5 1.5a.75.75 0 0 0 1.06 0l3-3a.75.75 0 0 0 0-1.06Z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "haidiMonthlyOverviewIcon_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h12v12H0z"
})))));
export default SvgHaidiMonthlyOverviewIcon;